import { TextBase } from '@carboncopyco/ui';

export const ErrorState = () => (
  <div className="flex flex-col items-center justify-center gap-2 h-full p-4">
    <TextBase
      label="Oops! Something went wrong"
      color="text-ds-natural-600"
    />
    <div className="text-center">
      <TextBase
        label="Looks like we’re experiencing a temporary server error. We’re on it!"
        color="text-ds-natural-400"
      />
    </div>
  </div>
);
